import React, { Component } from 'react';
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import { Link } from "react-router-dom";
import moment from 'moment';

interface AllProps {
    complaints: any;
    user: any;
    handleStatusChange: any;
    currentPath: string;
}

interface AllState {
    statuses: string[];
    forSoftwareTeamStatuses: string[];
    currentPath: string;
}

type ExportColumnDef = { header: string; cell: (item: Record<string, any>) => string };

export class ComplaintTable extends Component<AllProps, AllState> {
    state = {
        statuses: [
            "", "Valid", "Invalid", "New Requirement"
        ],
        forSoftwareTeamStatuses: [
            "", "Temporary Solution", "Completed", "Pending"
        ],
        currentPath: ""
    }
    componentDidMount() {
        const { currentPath } = this.props;
        this.setState({ currentPath });
        console.log("navigateto", currentPath);
        localStorage.setItem("complaint_route", currentPath);
    }

    componentDidUpdate(prevProps: AllProps) {
        if (prevProps.currentPath !== this.props.currentPath) {
            const { currentPath } = this.props;
            this.setState({ currentPath });
            localStorage.setItem("complaint_route", currentPath);
        }
    }

    private getEffectivePath(): string {
        return this.props.currentPath || this.state.currentPath;
    }

    private buildComplaintsData(complaints: any[]) {
        return complaints.map((report, index) => ({
            serial: index + 1,
            ticketId: report.ticketId,
            fileNo: report.fileNo ? report.fileNo : "",
            "Page Name": report.bankFormat ? report.bankFormat : "",
            location: report.location != null && report.location !== "" ? report.location : "",
            Problem: report.alreadyExist ? report.alreadyExist : "",
            Expectation: report.toBeChange ? report.toBeChange : "",
            Remark: report.remark ? report.remark : "",
            "Type of Issue":
                report.typeofIssue ||
                report.typeofissue ||
                report["typeofIssue"] ||
                "",
            createdDate: report.createdDate ? report.createdDate : "",
            updatedDate: report.updatedDate ? report.updatedDate : "",
            raisedBy: report.raisedBy ? report.raisedBy : "",
            "Lawhands Status": report.status ? report.status : "",
            "Lawhands Remark": report.lh_remark ? report.lh_remark : "",
            "Software Team Status": report.softwarestatus ? report.softwarestatus : "",
            "Software team Remark": report.softwareremark ? report.softwareremark : "",
            Attachment: report.complaint_file_name ? report.complaint_file_name : "",
        }));
    }

    private escapeCsvCell(value: unknown): string {
        const s = value == null ? "" : String(value);
        return `"${s.replace(/"/g, '""')}"`;
    }

    private getCellStringForTableKey(key: string, item: Record<string, any>): string {
        switch (key) {
            case "serial":
                return String(item.serial);
            case "ticketId":
                return String(item.ticketId ?? "");
            case "fileNo":
                return item.fileNo == "0" || item.fileNo === "" ? "-" : String(item.fileNo);
            case "Page Name":
                return item["Page Name"] || "-";
            case "location":
                return item.location != null && item.location !== "" ? String(item.location) : "-";
            case "Problem":
                return item.Problem ? String(item.Problem) : "-";
            case "Expectation":
                return item.Expectation ? String(item.Expectation) : "-";
            case "Remark":
                return item.Remark ? String(item.Remark) : "-";
            case "Type of Issue":
                return item["Type of Issue"] || "-";
            case "raisedBy":
                return String(item.raisedBy ?? "");
            case "createdDate":
                return item.createdDate != null && item.createdDate !== ""
                    ? moment(item.createdDate).format("DD/MM/YYYY HH:mm:ss")
                    : "-";
            case "updatedDate":
                return item.updatedDate != null && item.updatedDate !== ""
                    ? moment(item.updatedDate).format("DD/MM/YYYY HH:mm:ss")
                    : "-";
            case "Lawhands Status":
                return item["Lawhands Status"] ? item["Lawhands Status"] : "Pending";
            case "Lawhands Remark":
                return item["Lawhands Remark"] ? String(item["Lawhands Remark"]) : "-";
            case "Software Team Status":
                return item["Software Team Status"] ? item["Software Team Status"] : "Pending";
            case "Software team Remark":
                return item["Software team Remark"] || "-";
            case "Attachment":
                return item.Attachment ? String(item.Attachment) : "-";
            case "viewDetails":
                return "";
            default:
                return "";
        }
    }

    /** Visible table only — long text columns stay in Excel export only. */
    private buildTableColumns(effectivePath: string) {
        const columnsCommon = [
            {
                header: "S.no",
                key: "serial",
                td: (item: any) => <span>{item.serial}</span>,
            },
            {
                header: "Complaint No",
                key: "ticketId",
                td: (item: any) => <span>{item.ticketId}</span>,
            },
            {
                header: "File No",
                key: "fileNo",
                td: (item: any) => (
                    <span>{item.fileNo == "0" || item.fileNo == "" ? "-" : item.fileNo}</span>
                ),
            },
            {
                header: "Page Name",
                key: "Page Name",
                td: (item: any) => <span>{item["Page Name"] || "-"}</span>,
            },
            {
                header: "Type of Issue",
                key: "Type of Issue",
                td: (item: any) => <span>{item["Type of Issue"] || "-"}</span>,
            },
            {
                header: "Raised At",
                key: "createdDate",
                td: (item: any) => (
                    <span>
                        {item.createdDate != null && item.createdDate != ""
                            ? moment(item.createdDate).format("DD/MM/YYYY")
                            : "-"}
                    </span>
                ),
            },
            {
                header: "Completed At",
                key: "updatedDate",
                td: (item: any) => (
                    <span>
                        {item.updatedDate != null && item.updatedDate != ""
                            ? moment(item.updatedDate).format("DD/MM/YYYY")
                            : "-"}
                    </span>
                ),
            },
            {
                header: "Lawhands Status",
                key: "Lawhands Status",
                td: (item: any) => (
                    <span>{item["Lawhands Status"] ? item["Lawhands Status"] : "Pending"}</span>
                ),
            },
            {
                header: "Software Team Status",
                key: "Software Team Status",
                td: (item: any) => (
                    <span>{item["Software Team Status"] ? item["Software Team Status"] : "Pending"}</span>
                ),
            },
            {
                header: "Software team Remark",
                key: "Software team Remark",
                td: (item: any) => <span>{item["Software team Remark"] || "-"}</span>,
            },
            {
                header: "",
                key: "viewDetails",
                td: (item: any) => (
                    <span>
                        <Link to={`/view-complaint/${item.ticketId}`}>View Details</Link>
                    </span>
                ),
            },
        ];

        const raisedByColumn = {
            header: "Raised By",
            key: "raisedBy",
            td: (item: any) => <span>{item.raisedBy}</span>,
        };

        const columns = [...columnsCommon];
        if (effectivePath !== "/register-complaint") {
            columns.splice(3, 0, raisedByColumn);
        }
        return columns;
    }

    /** Full column set for CSV only (includes Location, Problem, Expectation, Remark, Lawhands Remark, Attachment). */
    private getExportColumnMetas(effectivePath: string): { header: string; key: string }[] {
        const tail: { header: string; key: string }[] = [
            { header: "Page Name", key: "Page Name" },
            { header: "Location", key: "location" },
            { header: "Problem", key: "Problem" },
            { header: "Expectation", key: "Expectation" },
            { header: "Remark", key: "Remark" },
            { header: "Type of Issue", key: "Type of Issue" },
            { header: "Raised At", key: "createdDate" },
            { header: "Completed At", key: "updatedDate" },
            { header: "Lawhands Status", key: "Lawhands Status" },
            { header: "Lawhands Remark", key: "Lawhands Remark" },
            { header: "Software Team Status", key: "Software Team Status" },
            { header: "Software team Remark", key: "Software team Remark" },
        ];
        const head: { header: string; key: string }[] = [
            { header: "S.no", key: "serial" },
            { header: "Complaint No", key: "ticketId" },
            { header: "File No", key: "fileNo" },
        ];
        if (effectivePath !== "/register-complaint") {
            head.push({ header: "Raised By", key: "raisedBy" });
        }
        return [...head, ...tail];
    }

    private exportMetasToDefs(metas: { header: string; key: string }[]): ExportColumnDef[] {
        return metas.map((c) => ({
            header: c.header,
            cell: (item: Record<string, any>) => this.getCellStringForTableKey(c.key, item),
        }));
    }

    private handleDownloadCsv = () => {
        const { complaints } = this.props;
        const effectivePath = this.getEffectivePath();
        const rows = this.buildComplaintsData(complaints);
        const defs = this.exportMetasToDefs(this.getExportColumnMetas(effectivePath));
        const headerLine = defs.map((d) => this.escapeCsvCell(d.header)).join(",");
        const dataLines = rows.map((row) => defs.map((d) => this.escapeCsvCell(d.cell(row))).join(","));
        const csv = "\uFEFF" + [headerLine, ...dataLines].join("\r\n");
        const title = `Software Complaints - ${moment().format("DD-MM-YYYY")}`;
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `${title}.csv`);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    render() {
        // const { complaints, user } = this.props;
        // complaints.forEach((complaint, index) => { complaint.serial = index + 1; });
        const { complaints, user } = this.props;
        complaints.forEach((complaint, index) => { complaint.serial = index + 1; });
        const { statuses, forSoftwareTeamStatuses, currentPath } = this.state;
        const User: any = localStorage.getItem("user");
        const userId = User ? JSON.parse(User)["userId"] : "";
        const roleType = User ? JSON.parse(User)["roleType"] : "";
        const role_label = User ? JSON.parse(User)["role_label"] : "";
        const complaintsdata = this.buildComplaintsData(complaints);
        const effectivePath = this.getEffectivePath();
        const columns = this.buildTableColumns(effectivePath);
        
        return (
            <div className="">
                <div style={{ marginBottom: 8, textAlign: "right" }}>
                    <button type="button" className="rft-excel-button _3nrH2" onClick={this.handleDownloadCsv}>
                        Download Excel
                    </button>
                </div>
                <ReactFlexyTable
                    className="assigned-table"
                    data={complaintsdata}
                    columns={columns}
                    sortable
                    pageSize={10}
                />
            </div>
        )
    }
}